// extracted by mini-css-extract-plugin
module.exports = {"staticTable":"StaticTable_staticTable__nfeVL"};